import React from "react";
import { motion } from "framer-motion";

const HeroPromo = () => {
  return (
    <section
  className="relative w-full min-h-[90vh] bg-cover bg-center overflow-hidden"
  style={{backgroundImage:"url('/assets/promo-hero-banner.png')",}}>
      {/* Overlay gelap */}
      <div className="absolute inset-0 bg-black/30" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20">
  
        {/* LEFT CONTENT */}
        <div>
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="inline-flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6"
          >
            🔥 Promo Terbatas
          </motion.div>

          {/* Title */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-white text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6"
          >
            Promo Spesial <br />
            Honda Minggu Ini
          </motion.h1>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-white/90 text-lg max-w-xl mb-8"
          >
            Dapatkan penawaran terbaik untuk motor Honda impian Anda.
            DP ringan, cicilan murah, dan bonus menarik!
          </motion.p>

          {/* CTA */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <a
              href="#promo-list"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-xl font-bold shadow-lg transition"
            >
              Lihat Semua Promo
            </a>
            <a
              href={
                "https://wa.me/6288293642972?text=" +
                encodeURIComponent(
                  "Halo Admin 👋\n\n" +
                  "Saya ingin menanyakan apakah saat ini ada *promo atau penawaran spesial* untuk produk dan layanan Honda.\n" +
                  "Mohon info detail promo yang sedang berlangsung.\n\n" +
                  "Terima kasih 🙏"
                )
              }
              target="_blank"
              rel="noopener noreferrer"
              className="
                bg-white/20 text-white
                px-8 py-4 rounded-xl font-bold
                backdrop-blur
                transition-all duration-300
                hover:bg-white/30 hover:scale-[1.05]
              "
            >
              Hubungi Kami
            </a>

          </motion.div>
        </div>

        
      </div>

      {/* Bottom fade putih */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
};

export default HeroPromo;
